import { render, staticRenderFns } from "./Florens.vue?vue&type=template&id=a1c20d80&"
import script from "./Florens.vue?vue&type=script&lang=js&"
export * from "./Florens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports